// ======================================================================
// File Name       : EnterpriseSearchForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Field, reduxForm, submit } from 'redux-form';
import { Form, Col, FormControl, Button } from 'react-bootstrap';

const DormantState = ({ input, label }) => (
  <Form.Check
    type="checkbox"
    name={input.name}
    id={input.name}
    label={label}
    checked={!!input.value}
    onChange={input.onChange}
  />
);

class EnterpriseSearchForm extends React.Component {
  render() {
    const props = this.props;
    const { error, handleSubmit, formSubmit } = props;
    return (
      <div>
        <Form onSubmit={handleSubmit(formSubmit)} className='form-horizontal'>
          <Col sm={12} className="margin-top-10">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                企業名
              </Col>
              <Col sm={7}>
                <Field type="text" name="enterpriseName" component="input" className="form-control" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                企業コード
              </Col>
              <Col sm={7}>
                <Field type="text" name="enterpriseCd" component="input" className="form-control" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={5} className="padding-top-bottom-clear margin-top-10">
                <Field
                  name="dormantState"
                  label="休止したデータも表示する"
                  component={DormantState}
                  type="checkbox"
                />
              </Col>
            </Form.Group>
          </Col>
          <Col sm={12}>
            <input type="submit" style={{ width: '0px', height: '0px', opacity: 0 }} id="submitBtn" name="submitBtn" />
          </Col>
        </Form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'enterpriseSearchForm',
  onSubmit: submit,
  touchOnChange: true,
  initialValues: { dormantState: true },
})(EnterpriseSearchForm);
